export const createURL = (str) => {
  return str
    .toLowerCase() // Convert to lowercase
    .trim() // Remove leading/trailing spaces
    .replace(/ /g, "_"); // Replace spaces with hyphens
};
